import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { toVw, toVwTablet, toVwMobile } from '../../../../utils/styles';
import Indent from '../../../../components/Indent';
import BigText from '../../../../components/BigText';
import Member from './components/Member';
import Cols from '../AboutCols';
import mq from '@/utils/media-queries';
import Media from '../../../../components/Media';

const Styled = styled.div``;

const Photo = styled(Media)`
  margin-bottom: ${toVw(180)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(180)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(144)};
  `)};
`;

const Preface = styled(BigText)`
  margin-bottom: ${toVw(280)};

  ${mq.mobile(css`
    font-size: ${toVwMobile(44)};
  `)};
`;

const MEMBER_MARGIN_BOTTOM = 144;

const Members = styled.div`
  margin-bottom: ${toVw(-MEMBER_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(-MEMBER_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(-MEMBER_MARGIN_BOTTOM)};
  `)};
`;

const StyledMember = styled(Member)`
  margin-bottom: ${toVw(MEMBER_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(MEMBER_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(MEMBER_MARGIN_BOTTOM)};
  `)};
`;

class Team extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    photo: PropTypes.string,
  };

  render() {
    const { items, photo } = this.props;

    return (
      <Styled className={this.props.className}>
        {photo && <Photo {...photo} />}
        <Indent>
          <Preface>
            В основе ярких идей и эффективных решений лежат опыт, знания и амбиции каждого члена нашей команды.
          </Preface>
          <Members>
            <Cols>
              {items.map((item, index) => (
                <Cols.Col key={index}>
                  <StyledMember {...item} />
                </Cols.Col>
              ))}
            </Cols>
          </Members>
        </Indent>
      </Styled>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/scenes/About/components/Team/index.js